import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { DirectivesModule } from './../../directives/directives.module';
import { OrderAddNotePage } from './order-add-note';

@NgModule({
  declarations: [OrderAddNotePage],
  imports: [IonicPageModule.forChild(OrderAddNotePage), DirectivesModule],
})
export class OrderAddNotePageModule {}



// WEBPACK FOOTER //
// ./src/pages/order-add-note/order-add-note.module.ts